module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cz-con"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h2', [_vm._v(_vm._s(_vm.titleName))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("可兑换金额：" + _vm._s(_vm.showTransfer))]), _vm._v(" "), _c('form', {
    staticClass: "alipayform",
    attrs: {
      "action": "api/user/transfer?tokenId=798cc3d3-56b0-44b2-848a-a3d6d306f253",
      "name": "transferForm",
      "method": "POST",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "element"
  }, [_c('div', {
    staticClass: "etitle"
  }, [_vm._v("兑换金额:")]), _vm._v(" "), _c('div', {
    staticClass: "einput"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transModel),
      expression: "transModel"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入需要兑换成通用商城购物积分的金额",
      "id": "WIDtotal_fee",
      "name": "WIDtotal_fee",
      "value": "10"
    },
    domProps: {
      "value": (_vm.transModel)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.transModel = $event.target.value
      }, _vm.getCalGold]
    }
  }), _vm._v(" "), (_vm.calGold1) ? _c('span', {
    staticStyle: {
      "margin-left": "10px",
      "color": "#ff0000"
    }
  }, [_vm._v("税后实际到账积分：" + _vm._s(_vm.calGold1))]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "element"
  }, [_c('div', {
    staticClass: "etitle"
  }, [_vm._v("支付密码:")]), _vm._v(" "), _c('div', {
    staticClass: "einput"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payPwd),
      expression: "payPwd"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入支付密码",
      "id": "WIDtotal_fee1",
      "name": "WIDtotal_fee",
      "value": "10",
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.payPwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payPwd = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "element"
  }, [_c('input', {
    staticClass: "alisubmit",
    attrs: {
      "type": "button",
      "value": "立即兑换"
    },
    on: {
      "click": function($event) {
        return _vm.doTransfer()
      }
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/account_logo.png"),
      "width": "200"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "element",
    staticStyle: {
      "display": "none"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "id": "tokenId",
      "name": "tokenId",
      "value": "798cc3d3-56b0-44b2-848a-a3d6d306f253"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-840fbd3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/account-center/showTransfer.vue
// module id = 1647
// module chunks = 1